
<footer class="footer text-center" id="app-footer">
  <ul *ngIf="isLogin">
    <li><a [routerLink]="['/legal-notices']"> {{footerTxt.legalNoticeLbl?footerTxt.legalNoticeLbl:footer.legalNoticeLbl}}</a></li>
    <li><a href="https://www.kawneer.com/privacy-policy/" target="_blank"> {{footerTxt.privacyPolicyLbl?footerTxt.privacyPolicyLbl:footer.privacyPolicyLbl}}</a></li>
    <li><a (click)="openTermsCondition();"> {{footerTxt.termsAndConditionsLbl?footerTxt.termsAndConditionsLbl:footer.termsAndConditionsLbl}}</a></li>
    <li><a [routerLink]="['/faq']"> {{footerTxt.FAQLbl?footerTxt.FAQLbl:footer.FAQLbl}}</a></li>
    <!--<li><a [routerLink]="['/contact-us']"> {{footerTxt.contactUsLbl?footerTxt.contactUsLbl:footer.contactUsLbl}}</a></li>-->
    <li><a href="https://www.kawneer.com/" target="blank"> {{footerTxt.kawneerComLbl?footerTxt.kawneerComLbl:footer.kawneerComLbl}}</a></li>
  </ul>

  <div class="col-12 footer-disclosure">
    <p>

      <br />
    </p>
    <p>
      {{footerTxt.footerDisclosureLbl?footerTxt.footerDisclosureLbl:footer.footerDisclosureLbl}}
      <br />
    </p>

    <span class="copyright">{{footerTxt.copyRightLbl?footerTxt.copyRightLbl:footer.copyRightLbl}}&copy;{{footerTxt.copyRightTxtLbl?footerTxt.copyRightTxtLbl:footer.copyRightTxtLbl}}.</span>
    <div [ngClass]="envName" class="envName">
      {{ envName }}
      <span *ngIf="InstanceId" class="server">
     {{ InstanceId }}
      </span>
      <span *ngIf="serverName" class="server">
        / {{ serverName }} : {{ currentDateTime | date: 'dd-MMM-yyyy HH:mm:ss a'}}
      </span>
      <span *ngIf="buildDate" class="server">
        / Build: {{ buildDate | date: 'yyyyMMdd'}}
      </span>

    </div>
  </div><!--end footer-disclosure-->
</footer><!--end footer-->
